import React from 'react';
import { InView } from 'react-intersection-observer';

import Bottom from '@components/StickyBanner/Bottom/Content';
import useEventTracking from '@hooks/useEventTracking';
import { ImpressionElement, TrackingLocation, impression } from '@tracking';
import { FormLocation, LeadType } from '@utils/enums';

import { PaywallProps } from '.';

const PaywallBanner = ({
  articleId,
  buttonText,
  leadType = LeadType.ArticleLead,
  isPro,
  offerLink,
  title,
}: PaywallProps): JSX.Element => {
  const { Track, trackEvent } = useEventTracking({ location: TrackingLocation.Paywall });
  return (
    <aside
      className="fixed bottom-0 left-0 right-0 z-[9999]"
      id="read-this-article"
      data-testid="paywall-banner"
    >
      <Track>
        <InView
          triggerOnce={true}
          onChange={(inView) => {
            inView &&
              trackEvent(impression({ impressionElement: ImpressionElement.PaywallBanner }));
          }}
        >
          <Bottom
            articleId={articleId}
            buttonText={buttonText}
            formLocation={FormLocation.PaywallStickyBanner}
            headline={title}
            hideUntilScroll={false}
            isLoggedIn
            isPro={isPro}
            leadType={leadType}
            submitLink={offerLink}
          />
        </InView>
      </Track>
    </aside>
  );
};

export default PaywallBanner;
